import request from "../../untils/request";

export function selectList(param) {

    return request({
        url: '/roleModule',
        method: 'get',
        params: param
    })
}



export function add(data) {

    return request({
        url: '/roleModule',
        method: 'post',
        data: data
    })
}


